// src/services/productService.js
import axiosInstance from './axiosConfig';

const productService = {
  // Get all products with pagination
  getProducts: async (page = 1, limit = 10000) => {
    const response = await axiosInstance.get(`/products?page=${page}&limit=${limit}`);
    return response.data.data ?? response.data;
  },

  // Search products
  searchProducts: async (searchTerm, page = 1, limit = 50) => {
    const response = await axiosInstance.get(`/products?search=${searchTerm}&page=${page}&limit=${limit}`);
    return response.data.data ?? response.data;
  },

  // Get products by category
  getProductsByCategory: async (categoryId, page = 1, limit = 50) => {
    const response = await axiosInstance.get(`/products?categoryId=${categoryId}&page=${page}&limit=${limit}`);
    return response.data.data ?? response.data;
  },

  // Get active categories - FIXED to match your actual API
  getActiveCategories: async () => {
    const response = await axiosInstance.get('/categories/all');
    const categories = response.data.data ?? response.data;
    
    // Debug logging
    console.log('Categories from API:', categories);
    
    // Filter only active categories if needed
    // If your API doesn't have an isActive field, remove this filter
    return categories.filter(cat => cat.isActive !== false);
  },

  // Alternative: Get all categories without filtering
  getAllCategories: async () => {
    const response = await axiosInstance.get('/categories');
    return response.data.data ?? response.data;
  },

  // Add products (batch)
  addProducts: async (payload) => {
    const response = await axiosInstance.post('/products/add', payload);
    return response.data;
  },

  // Update a single product - FIXED to match your API endpoint
  updateProduct: async (productId, payload) => {
  const wrappedPayload = {
    updateProduct: payload  // <-- Wrapping the payload
  };
  
  const response = await axiosInstance.put(`/products/edit/${productId}`, wrappedPayload);
  return response.data;
},

  // Delete a product - FIXED to match your API endpoint
  deleteProduct: async (productId) => {
    const response = await axiosInstance.delete(`/products/delete/${productId}`);
    return response.data;
  },

  // Get single product by ID
  getProductById: async (productId) => {
    const response = await axiosInstance.get(`/products/${productId}`);
    return response.data.data ?? response.data;
  }
};

export default productService;